import _Upload from './upload';
import type { TdUploadProps as UploadProps } from './type';
import './style/index.js';

export const Upload = _Upload;

export type { UploadProps };
export * from './type';

export default Upload;
